module.exports = {
    failed: 'Указанные реквизиты не найдены в нашей базе данных.',
    throttle: 'Слишком много попыток входа. Пожалуйста, повторите попытку через :seconds секунд.',
}